
async function loadAndUpdateUpsellModal(id){
  const submitButton = document.querySelector(`.realSubmit--${id}`);
  submitButton.click();
  setButtonLoadSpinner(`upsellModalMainButton--${id}`, 3000, 16);
  setTimeout(() => closeUpsellModal(), 2000)
  setTimeout(async () => await refreshCart(), 500);
}

function closeUpsellModal(){
  const upsellModal = document.querySelectorAll('.upsell-modal-container')
  if(upsellModal){
    upsellModal.forEach(modal => {
      modal.classList.add('modal-hidden')
      modal.classList.remove('modal-visible')
    })
  }
}